import React, { useState } from 'react';
import { Button, Col, Input, Modal, Row, Select, Space } from 'antd';
import { updateProject } from '@gtintel/platform-api';
import { CloseModalIcon } from '@gtintel/platform-atoms';
import { CLOSED_ID } from '@gtintel/platform-constants';
import { RouteRolesEnum } from '@gtintel/platform-types';
const CloseProjectModal = props => {
  const {
    visible,
    closeModal,
    changeProjectStatus,
    projectDetail
  } = props;
  const [reason, setReason] = useState('');
  const [comments, setComments] = useState('');
  const [showError, setShowError] = useState(false);
  const onSubmit = async e => {
    e.preventDefault();
    if (reason === '') {
      setShowError(true);
    } else {
      await updateProject(projectDetail.id, projectDetail.project_type, {
        closed_reason: reason,
        closed_reason_additional_comments: comments,
        was_closed_by_admin: true
      });
      changeProjectStatus(CLOSED_ID, RouteRolesEnum.ADMIN);
      closeModal();
    }
  };
  const items = [{
    value: 'Price / Budget'
  }, {
    value: 'Alternative Provider'
  }, {
    value: 'Product / Service'
  }, {
    value: 'No longer have a requirement'
  }, {
    value: 'Not known'
  }, {
    value: 'Other'
  }];
  return <Modal visible={visible} title="Close Project?" closeIcon={<CloseModalIcon />} onCancel={closeModal} footer={[<Button type="primary" onClick={onSubmit}>
          Close Project
        </Button>, <Button onClick={closeModal}>Cancel</Button>]}>
      <Space direction="vertical" size="small" style={{
      display: 'flex'
    }}>
        <Row>
          <Col span={24}>
            <p>
              Once you close this project, the Network Partner will no longer
              have access to the project space or chat.
            </p>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <label>
              Select the reason for closing this project:
              <span style={{
              color: 'red',
              display: showError ? 'block' : 'none'
            }}>
                Reason is required.
              </span>
              <Select options={items} onSelect={value => {
              setShowError(false);
              setReason(value);
            }} />
            </label>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <label>
              Add an optional explanation:
              <Input.TextArea value={comments} onChange={e => setComments(e.target.value)} />
            </label>
          </Col>
        </Row>
      </Space>
    </Modal>;
};
export default CloseProjectModal;